import React, { PropsWithChildren } from "react";
import { ChatSettingsV2 } from "../entities/ChatSettingsV2";
import { Box, Card, Separator } from "@radix-ui/themes";
import { Footer } from "./Footer";

interface QuackWidgetCardProps {
  settings: ChatSettingsV2;
}

export function QuackWidgetCard({
  children,
  settings: { poweredByLine },
}: PropsWithChildren<QuackWidgetCardProps>) {
  return (
    <Box className="qc-Chat__Widget">
      <Card
        variant="classic"
        size={"5"}
        style={{
          height: "100%",
          padding: "0",
          display: "flex",
          flexDirection: "column",
          position: "relative",
        }}
        className="qc-Chat__Widget__Card"
      >
        {children}

        {poweredByLine && (
          <>
            <Separator orientation="horizontal" size="4" />
            <Footer />
          </>
        )}
      </Card>
    </Box>
  );
}
